import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Header from "../Layout/Header/Header";
import Footer from "../Layout/Footer/Footer";
import CustomLoader from "../CustomComponents/CustomLoader/CustomLoader";

import "./CartBrands.css";
import EmptyCart from "../Cart/EmptyCart";
import { getCartBrandsAPI } from "../../../Store/Action/cartAction";

const CartBrands = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [brands, setBrands] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchBrands = useCallback(() => {
    dispatch(
      getCartBrandsAPI({}, (result) => {
        if (result?.status) {
          setBrands(Array.isArray(result.data) ? result.data : []);
        }
        setIsLoading(false);
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    fetchBrands();
  }, [fetchBrands]);

  const handleBrandClick = (manufacturerId) => {
    navigate("/cart", { state: { manufacturer_id: manufacturerId } });
  };

  return (
    <div className="cart-brands-page">
      <Header />

      <div className="cart-brands-body">
        {isLoading ? (
          <div className="cart-brands-loader">
            <CustomLoader />
          </div>
        ) : brands.length === 0 ? (
          <EmptyCart />
        ) : (
          <>
            <h2 className="cart-brands-heading">Shopping Cart</h2>

            <div className="cart-brands-grid">
              {brands.map((brand) => (
                <div key={brand.manufacturer_id} className="cart-brand-card">
                  {/* Logo image — full card top */}
                  <div className="cart-brand-image-wrap">
                    {brand.brand_image_url ? (
                      <img
                        src={brand.brand_image_url}
                        alt={brand.brand_name}
                        className="cart-brand-image"
                      />
                    ) : (
                      <div className="cart-brand-image-placeholder">
                        {brand.brand_name?.[0]?.toUpperCase() || "B"}
                      </div>
                    )}
                  </div>

                  {/* Info below image */}
                  <div className="cart-brand-info">
                    <p className="cart-brand-name">{brand.brand_name}</p>
                    <p className="cart-brand-item-count">
                      {brand.product_count}{" "}
                      {brand.product_count === 1 ? "Product" : "Products"}
                    </p>
                    <p className="cart-brand-item-count">Total Fine : {brand.total_fine}g </p>
                    <button
                      className="cart-brand-continue-btn"
                      onClick={() => handleBrandClick(brand.manufacturer_id)}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default CartBrands;
